import script from "./TableDraggableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableDraggableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TableDraggableComponent.vue?vue&type=style&index=0&id=5060075f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5060075f"]])

export default __exports__